export default __webpack_public_path__ + "static/media/Montserrat-Light.3a31a5e9.woff";